/**
 * Sends an analytics event using Adobe Alloy SDK
 * @async
 * @function sendEvent
 * @param {Object} options - Configuration options for the analytics event
 * @param {boolean} [options.documentUnloading=true] - Indicates if the document is unloading
 * @param {string} [options.type='web.webinteraction.linkClicks'] - Type of analytics event
 * @param {Object} [options.xdm=window.digitalData] - XDM (Experience Data Model) data object
 * @param {Object|null} [options.data=null] - Analytics data containing activity map information
 * @param {string} [options.data.page] - Page identifier for activity mapping
 * @param {string} [options.data.link] - Link identifier for activity mapping
 * @param {string} [options.data.region] - Region identifier for activity mapping
 * @param {number} [options.data.pageIDType] - Page ID type for activity mapping
 * @returns {Promise<void>} Promise that resolves when the event is sent
 * @description Sends analytics events to Adobe Experience Platform via Alloy SDK.
 * Only executes in browser environment when window object exists and data is provided.
 */
export const sendAnalyticsWebEvent = async ({
  documentUnloading = true,
  type = 'web.webinteraction.linkClicks',
  xdm = window.digitalData,
  data = null
}) => {
  if (typeof window !== 'undefined' && data) {
    await window.alloy(
      'sendEvent',
      {
        documentUnloading,
        type,
        xdm,
        data: {
          __adobe: {
            analytics: {
              contextData: {
                // eslint-disable-next-line id-length
                a: {
                  activitymap: {
                    page: data?.pageName || window?.digitalData?.page?.pageInfo?.pageName,
                    link: data.link,
                    region: data.region,
                    pageIDType: data.pageIDType
                  }
                }
              }
            }
          }
        }
      }
    );
  }
};
